function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.98876 1.0026C9.91432 1.01064 9.84478 1.04358 9.7914 1.09608L1.451 9.44169C1.40152 9.49095 1.36881 9.55454 1.3575 9.62344L1.00436 11.8566C0.996414 11.9082 1.00074 11.9609 1.01698 12.0105C1.03322 12.0602 1.06093 12.1053 1.09785 12.1422C1.13477 12.1791 1.17987 12.2068 1.22949 12.223C1.27912 12.2393 1.33187 12.2436 1.38348 12.2357L3.61659 11.8825C3.68488 11.8727 3.7484 11.8418 3.79836 11.7942L12.144 3.44864C12.1752 3.41773 12.2 3.38092 12.2169 3.34036C12.2339 3.2998 12.2426 3.25629 12.2426 3.21234C12.2426 3.16839 12.2339 3.12488 12.2169 3.08432C12.2 3.04376 12.1752 3.00696 12.144 2.97605L10.264 1.09608C10.2282 1.06067 10.1848 1.03385 10.1371 1.01765C10.0895 1.00146 10.0387 0.996316 9.98876 1.0026ZM10.0251 1.80237L11.4377 3.21494L10.8508 3.80178L9.43826 2.38921L10.0251 1.80237ZM8.96568 2.8618L10.3783 4.27437L3.79836 10.8543L2.38579 9.44169L8.96568 2.8618ZM1.97551 9.9662L3.27383 11.2645L1.73142 11.5086L1.97551 9.9662Z",
  fill: "#2D4170",
  stroke: "#2D4170",
  strokeWidth: 0.273913
});

var _ref3 = /*#__PURE__*/React.createElement("line", {
  x1: 1.68478,
  y1: 14.4046,
  x2: 11.3417,
  y2: 14.4046,
  stroke: "#2D4170",
  strokeWidth: 1.36957,
  strokeLinecap: "round"
});

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.a40b6736.svg";
export { ForwardRef as ReactComponent };